import { AnnouncedProps } from "@amx/ux-twoui-accessibility";
import { Announced as FluentAnnounced } from "@fluentui/react";
import React from "react";
import { useComponentLogger } from "../../shared/logging";

export const Announced: React.FC<AnnouncedProps> = ({
    message,
    ariaLive = "polite",
    ...otherProps
}) => {
    useComponentLogger("Announced");

    return (
        <FluentAnnounced message={message} aria-live={ariaLive} {...otherProps} />
    );
};
